export const messages = {
  zh: {
    electricMeter: {
      search: {
        title: '查询条件',
        meterNo: '电表号',
        remark: '商铺名称',
        meterType: '电表类型',
        phaseType: '相线类型',
        state: '状态'
      },
      list: {
        title: '电表列表',
        addElectricMeter: '添加电表'
      },
      table: {
        meterNo: '电表号',
        meterType: '电表类型',
        phaseType: '相线类型',
        roomNum: '房屋编号',
        parentMeterNo: '上级电表',
        remark: '商铺名称',
        state: '状态',
        createTime: '创建时间',
        operation: '操作'
      },
      form: {
        title: '电表信息',
        meterNo: '电表号',
        meterType: '电表类型',
        phaseType: '相线类型',
        roomNum: '房屋编号',
        parentMeterId: '上级电表ID',
        remark: '商铺名称',
        state: '状态',
        pleaseInput: '请输入',
        pleaseSelect: '请选择'
      },
      meterType: {
        main: '总表',
        sub: '分表',
        independent: '独立表'
      },
      phaseType: {
        single: '单相',
        three: '三相'
      },
      state: {
        enabled: '启用',
        disabled: '停用'
      }
    }
  }
}